import { formatCountdown } from './utils';
import {
  ACTIVE_RENDER_STATUSES,
  MEANINGFUL_RENDER_STATUSES,
  PIPELINE_STEP_STATUS,
} from './constants';

export function getVoiceOverStatus(item) {
  const status = item.voiceOverGenerationStatus?.status;
  if (status === 'queued') return 'queued';
  if (status === 'generating' || status === 'generating-voiceover') return 'generating';
  if (status === 'failed') return 'failed';
  if (status === 'completed' || item.voiceOverObjectName) return 'completed';
  return 'idle';
}

export function getRenderProgress(renderStatus, voiceOverDuration, now = Date.now()) {
  const status = renderStatus?.status;
  if (!status || !ACTIVE_RENDER_STATUSES.includes(status)) return null;
  if (status === 'queued') return { text: 'In queue' };
  if (status === 'setting_up') return { text: 'Setting up…' };
  if (status === 'finalizing') return { text: 'Finalizing…' };
  if (status === 'rendering') {
    const startedAt = renderStatus.renderStartedAt
      ? new Date(renderStatus.renderStartedAt).getTime()
      : now;
    const estimatedSec =
      renderStatus.estimatedDurationSec ??
      Math.ceil((voiceOverDuration || 60) / 3.8);
    const elapsed = (now - startedAt) / 1000;
    const remaining = Math.max(0, estimatedSec - elapsed);
    const progress = Math.min(99, Math.round((elapsed / estimatedSec) * 100));
    return {
      text: `${formatCountdown(remaining)} left`,
      progress,
    };
  }
  return null;
}

export function hasMeaningfulRenderStatus(status) {
  return MEANINGFUL_RENDER_STATUSES.includes(status);
}

export function getScriptStepStatus(doc) {
  const s = doc?.generationStatus?.status || 'idle';
  if (s === 'completed') return PIPELINE_STEP_STATUS.completed;
  if (s === 'failed') return PIPELINE_STEP_STATUS.failed;
  if (s === 'generating' || s === 'queued' || s === 'rate limit') return PIPELINE_STEP_STATUS.in_progress;
  return PIPELINE_STEP_STATUS.pending;
}

export function getVoiceOverStepStatus(doc) {
  if (doc?.voiceOverObjectName) return PIPELINE_STEP_STATUS.completed;
  const s = doc?.voiceOverGenerationStatus?.status;
  if (s === 'queued' || s === 'generating' || s === 'generating-voiceover') return PIPELINE_STEP_STATUS.in_progress;
  if (s === 'failed') return PIPELINE_STEP_STATUS.failed;
  return PIPELINE_STEP_STATUS.pending;
}

export function getRenderStepStatus(doc) {
  const s = doc?.renderStatus?.status;
  if (s === 'completed') return PIPELINE_STEP_STATUS.completed;
  if (s === 'failed') return PIPELINE_STEP_STATUS.failed;
  if (ACTIVE_RENDER_STATUSES.includes(s)) return PIPELINE_STEP_STATUS.in_progress;
  return PIPELINE_STEP_STATUS.pending;
}
